import gql from 'graphql-tag';

const query = gql`
  query CheckoutUserData {
    me {
      id
      email
    }
  }
`;

export default query;
